'use strict'

define ['./removeModal.css','./apptemplatesTable.scss'], () ->
  ($state, $rootScope, ApplicationTemplate, RENTAPPLICATION_API_URL, $uibModal, $cacheFactory, $timeout) ->
    restrict: "E"
    template: require("./apptemplatesTable.jade")
    link: (scope, element, attrs) ->
      scope.plus_svg = require('./plus.svg')
      scope.no_form_plus_svg = require('./no_form_plus.svg')
      scope.copied = []

      scope.go_to_edit = (apptemplate) ->
        $state.go("root.applications.form_edit", { application_template_slug: apptemplate.slug })
        #window.location.replace("#{$rootScope.HOST}/forms/#{apptemplate.slug}/edit/")
      
      scope.view_slug = (apptemplate) ->
        window.open("#{$rootScope.HOST}/#{apptemplate.slug}/", "_blank")
        return true
      
      scope.copy_form_link = (apptemplate, index) ->
        scope.copied["#{index}"] = true
        scope.app_slug_link = "#{$rootScope.HOST}/#{apptemplate.slug}"
        
        if apptemplate.has_agent_field
          scope.app_slug_link += "?a=#{btoa($rootScope.user.username)}"

      scope.update_show_report = () ->
        scope.rowCollection.map((apptemplate) ->
          if _.find(apptemplate.landlord.report_source_profiles, {'short_label': 'Identity'})
            apptemplate.landlord.show_identity_report = true

          if _.find(apptemplate.landlord.report_source_profiles, {'short_label': 'Employment'})
            apptemplate.landlord.show_employment_report = true
          
          if _.find(apptemplate.landlord.report_source_profiles, {'short_label': 'Income'})
            apptemplate.landlord.show_income_report = true
          
          if _.find(apptemplate.landlord.report_source_profiles, {'short_label': 'Current Landlord'})
            apptemplate.landlord.show_current_landlord_report = true

          if _.find(apptemplate.landlord.report_source_profiles, {'short_label': 'Previous Landlord'})
            apptemplate.landlord.show_previous_landlord_report = true             
        )
      scope.update_show_report()
        
      scope.create_new = () ->
        $state.go("root.forms.select_reports", { data: {} })

      scope.open_delete_modal = (id) ->
        scope.current_id = id

        $uibModal.open
          scope: scope
          template: require("./removeModal.jade")
          controller: require("./removeModal.coffee")
          windowClass: 'apptemplate-delete'
        .result.then () ->
          scope.current_id = null

      scope.refresh_list = () ->
        $cacheFactory.get("$http").removeAll()
        ApplicationTemplate.query().$promise
          .then (apptemplates) ->
            scope.rowCollection = apptemplates.objects

      $rootScope.$on 'forms-changed', (event, args) ->
        scope.refresh_list()

      $rootScope.$on 'paginate', (event, data) ->
        scope.is_loading = true
        ApplicationTemplate.query
          limit: 25
          offset: data.offset
        .$promise.then (apptemplates) ->
          scope.rowCollection = apptemplates.objects
          scope.is_loading = false
          scope.update_show_report()
          



// WEBPACK FOOTER //
// ./directives/apptemplatesTable/apptemplatesTable.coffee